import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  Box,
  IconButton,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useScrollTrigger,
  Slide,
} from "@mui/material";
import {
  Menu as MenuIcon,
} from "@mui/icons-material";
import "./Navigation.css";

// HideOnScroll component for mobile/touch devices
const HideOnScroll = ({ children }) => {
  const trigger = useScrollTrigger();
  const isTouchDevice = "ontouchstart" in window;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Only hide on mobile or touch devices
  if (!isMobile && !isTouchDevice) {
    return children;
  }

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    const routes = ["/", "/about", "/guides", "/chart-maker", "/gallery"];
    navigate(routes[newValue]);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getCurrentTab = () => {
    const routes = ["/", "/about", "/guides", "/chart-maker", "/gallery"];
    return routes.indexOf(location.pathname);
  };

  const navigationItems = [
    { label: "Welcome", path: "/" },
    { label: "About", path: "/about" },
    { label: "Guides", path: "/guides" },
    { label: "Chart Maker", path: "/chart-maker" },
    { label: "Gallery", path: "/gallery" },
  ];

  const drawer = (
    <Box className="nav-drawer">
      <Toolbar className="nav-drawer-toolbar">
        <div className="nav-drawer-title">
          <img
            src="/logo.png"
            alt="Loops & Purls"
            className="nav-drawer-logo"
          />
        </div>
      </Toolbar>
      <List>
        {navigationItems.map((item, index) => {
          return (
            <ListItem key={item.label} disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate(item.path);
                  setMobileOpen(false);
                }}
                selected={location.pathname === item.path}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  return (
    <>
      <HideOnScroll>
        <AppBar position="sticky">
          <Toolbar>
            {isMobile && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className="nav-mobile-menu-button"
              >
                <MenuIcon />
              </IconButton>
            )}

            <div
              className={isMobile ? "nav-brand" : "nav-brand nav-brand-desktop"}
            >
              <img src="/logo.png" alt="Loops & Purls" className="nav-logo" />
            </div>

            {!isMobile && (
              <Tabs
                value={getCurrentTab()}
                onChange={handleTabChange}
                textColor="inherit"
                className="nav-tabs"
              >
                {navigationItems.map((item, index) => {
                  return <Tab key={item.label} label={item.label} />;
                })}
              </Tabs>
            )}

          </Toolbar>
        </AppBar>
      </HideOnScroll>

      <Drawer
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        {drawer}
      </Drawer>

      {/* Auth menu removed */}
    </>
  );
};

export default Navigation;
